import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const makeLink = (link, label, className) =>
  <li key={label}>
    <Link to={link} className={className}>
      {label}
    </Link>
  </li>;

const Pager = props => {
  const { intl, link, total: totalItems, pageSize, currentPage = 1 } = props;

  const totalPages = Math.ceil(totalItems / pageSize);
  const links = [];

  if (totalPages > 3) {
    // this specifies the range of pages we want to show in the middle
    const start = Math.max(
      totalPages - currentPage <= 3 ? totalPages - 4 : currentPage - 2,
      2
    );
    const end = Math.min(
      currentPage <= 4 ? 5 : currentPage + 2,
      totalPages - 1
    );

    // we always show the first page
    links.push(1);

    // we're more than one space away from the beginning, so we need a separator
    if (start > 2) {
      links.push("...");
    }

    // generate the middle numbers
    for (let i = start; i < end + 1; ++i) {
      links.push(i);
    }

    // we're more than one space away from the end, so we need a separator
    if (end < totalPages - 1) {
      links.push("...");
    }

    // we always show the last page
    links.push(totalPages);
  } else {
    // we must special-case three or less, because the above logic won't work
    // generate the middle numbers
    for (let i = 1; i <= totalPages; ++i) {
      links.push(i);
    }
  }

  const prevLink =
    currentPage > 1 &&
    makeLink(
      link(currentPage - 1),
      intl.formatMessage(messages.previousTextDescription)
    );

  const nextLink =
    currentPage < totalPages &&
    makeLink(
      link(currentPage + 1),
      intl.formatMessage(messages.nextTextDescription)
    );

  return (
    <ul className="apl-pager">
      {prevLink}
      {links.map(
        (x, idx) =>
          x === "..."
            ? <li key={`ellip-${idx}`}>…</li>
            : makeLink(
                link(x),
                intl.formatNumber(x),
                x === currentPage ? "apl-pager__current" : null
              )
      )}
      {nextLink}
    </ul>
  );
};

Pager.propTypes = {
  total: PropTypes.number,
  currentPage: PropTypes.any,
  pageSize: PropTypes.number,
  link: PropTypes.func,
  intl: intlShape.isRequired,
};

export default injectIntl(Pager);



// WEBPACK FOOTER //
// ./components/pager.jsx